import { render, staticRenderFns } from "./DialogCard.vue?vue&type=template&id=174c5ddc"
import script from "./DialogCard.vue?vue&type=script&lang=js"
export * from "./DialogCard.vue?vue&type=script&lang=js"
import style0 from "./DialogCard.vue?vue&type=style&index=0&id=174c5ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports